<script lang="babel">
export default{
  methods: {
    onLogin () {
      console.log(1)
      this.$router.push('/dashboard')
    }
  }
}
</script>
<template lang="pug">
div
  v-toolbar(
    color="primary"
    dark
    app
    fixed
    )
    v-toolbar-side-icon
    v-toolbar-title Molinor
    v-spacer
    v-btn(icon)
      v-icon more_vert
  v-content
    v-container(
      fluid
      fill-height
    )
      v-layout(
        justify-center
        align-center
      )
        v-flex(
          xs12
          sm8
          md4
          )
          v-card(class="elevation-12")
            v-toolbar(
              dark
              color="primary"
            )
              v-toolbar-title Inicio de Sesión
            v-card-text
              v-form
                v-text-field(
                  label="Usuario"
                  prepend-icon="person"
                )
                v-text-field(
                  label="Contraseña"
                  type="password"
                  prepend-icon="lock"
                )
            v-card-actions
              v-spacer
              v-btn(
                @click.prevent="onLogin"
                color="primary"
              ) Ingresar
</template>
